export class AutoCompleteItem {

    public id : string = '';
    
    public name : string = '';
    
    public extraData : any = {};
}
